webpackJsonp([35783957827783],{

/***/ 21:
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	    module.exports['default'] = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  /*eslint-disable */
	  var charMap = JSON.parse('{"$":"dollar","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","џ":"dz","Ґ":"G","ґ":"g","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₹":"indian rupee","₽":"russian ruble","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial"}')
	  /*eslint-enable */
	
	  function replace (string, options) {
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    string = string.split('')
	      .reduce(function (result, ch) {
	        if (charMap[ch]) {
	          ch = charMap[ch]
	        }
	        // allowed
	        ch = ch.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	        result += ch
	        return result
	      }, '')
	      // trim leading/trailing spaces
	      .replace(/^\s+|\s+$/g, '')
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? string.toLowerCase() : string
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),

/***/ 211:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _slugify = __webpack_require__(21);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: 'button button-start', to: '/lesson/' + (0, _slugify2.default)(data.lessons.edges.filter(function (lesson) {
	        if (lesson.node.frontmatter.module === data.modules.edges[0].node.frontmatter.title) return lesson;
	      })[0].node.frontmatter.title, { lower: true }), role: 'button' },
	    'Start learning'
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 214:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.courseOverviewQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(14);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(566);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _slugify = __webpack_require__(21);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _startButton = __webpack_require__(211);
	
	var _startButton2 = _interopRequireDefault(_startButton);
	
	var _phaseBanner = __webpack_require__(55);
	
	var _phaseBanner2 = _interopRequireDefault(_phaseBanner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero' },
	      _react2.default.createElement(
	        'div',
	        { className: 'page-container' },
	        _react2.default.createElement(_phaseBanner2.default, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'grid-row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column-two-thirds' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'heading-xlarge' },
	              'Build a web app in six months'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'lede' },
	              'Learn to code is a series of lessons on the technology behind government services.'
	            ),
	            _react2.default.createElement(_startButton2.default, { data: data }),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/page/why-this-exists' },
	                'Read about why this exists'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'column-one-third' },
	            _react2.default.createElement('img', { src: _logo2.default, alt: 'Learn to code' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'grid-row' },
	      _react2.default.createElement(
	        'div',
	        { className: 'column-two-thirds' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'heading-large' },
	          'Step by step'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'New modules are released monthly. Each one should take a day or two to complete.'
	        ),
	        _react2.default.createElement(
	          'ol',
	          { className: 'course-overview-list' },
	          data.modules.edges.map(function (module) {
	            return _react2.default.createElement(
	              'li',
	              { className: 'module', key: module.node.frontmatter.title },
	              _react2.default.createElement(
	                'span',
	                { className: 'number' },
	                module.node.frontmatter.order
	              ),
	              _react2.default.createElement(
	                'h3',
	                { className: 'heading-medium' },
	                module.node.frontmatter.title
	              ),
	              _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: module.node.html } }),
	              module.node.frontmatter.visible ? _react2.default.createElement(
	                'details',
	                null,
	                _react2.default.createElement(
	                  'summary',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'summary' },
	                    'Show lessons'
	                  )
	                ),
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(
	                    'ol',
	                    { className: 'lesson-list' },
	                    data.lessons.edges.filter(function (lesson) {
	                      if (lesson.node.frontmatter.module === module.node.frontmatter.title) return lesson;
	                    }).map(function (lesson) {
	                      return _react2.default.createElement(
	                        'li',
	                        { key: lesson.node.frontmatter.title },
	                        _react2.default.createElement(
	                          _gatsbyLink2.default,
	                          { to: '/lesson/' + (0, _slugify2.default)(lesson.node.frontmatter.title, { lower: true }) },
	                          lesson.node.frontmatter.title
	                        ),
	                        lesson.node.frontmatter.type === 'project' ? _react2.default.createElement(
	                          'span',
	                          { className: 'project-badge' },
	                          'P'
	                        ) : ""
	                      );
	                    })
	                  )
	                )
	              ) : _react2.default.createElement(
	                'span',
	                { className: 'unavailable' },
	                'This module is not yet available'
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	var courseOverviewQuery = exports.courseOverviewQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 566:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.9fd35dee.png";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-9a90ea5e6ee12400d12e.js